// Teams Chat Type enum (matching MS Graph API)
export enum TeamsChatType {
  ONE_ON_ONE = 'oneOnOne',
  GROUP = 'group',
  MEETING = 'meeting',
}

export const TEAMS_CHAT_TYPES: ReadonlySet<TeamsChatType> = new Set([
  TeamsChatType.ONE_ON_ONE,
  TeamsChatType.GROUP,
  TeamsChatType.MEETING,
]);

// Member stored inline in the chat cache item
export interface TeamsChatCacheMember {
  teamsUserId: string;
  displayName?: string;
  email?: string;
  tenantId?: string;
}

// Full cache item (chat with members inline)
export interface TeamsUserChatCacheItem {
  userId: string; // Partition key - our system's userId
  chatId: string; // Sort key - Teams chat ID
  chatType: TeamsChatType;
  topic?: string | null;
  tenantId?: string;
  /** Microsoft account this chat is reachable through. Same readability justification as UserCommunicationFields.teamsHomeAccountId (encryption.md exception 1). */
  homeAccountId?: string;
  members: TeamsChatCacheMember[];
  refreshedAt: number;
}
